import React, { useRef } from "react";
import { CgChevronDoubleRight } from "react-icons/cg";
const ScrollBtn = () => {
  const scrollBtn = useRef();
  window.addEventListener("scroll", () => {
    if (window.scrollY > 250) {
      scrollBtn.current.classList.remove("translate-x-20");
      scrollBtn.current.classList.remove("translate-y-20");
      return;
    }
    scrollBtn.current.classList.add("translate-x-20");
    scrollBtn.current.classList.add("translate-y-20");
  });
  return (
    <button
      className="fixed bottom-3 right-3 sm:bottom-4 sm:right-5 md:bottom-5 md:right-6 bg-scColor/80 hover:bg-prColor focus:bg-prColor focus:border-borderColor p-3 border border-borderColor rounded-full text-light translate-x-20  transition-all ease-out z-10"
      ref={scrollBtn}
      onClick={() => window.scrollTo(0, 0)}
    >
      <CgChevronDoubleRight className="text-2xl text-light -rotate-90" />
    </button>
  );
};

export default ScrollBtn;
